/* eslint-disable */
import React from 'react'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {accounting} from 'accounting'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'

class RemainDriverComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  componentDidMount() {}

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    const {urlSign} = this.state

    let {remainInfo, aggregation, singleDriver} = this.props

    return (
      <div className="showBaseTable print">
        <table className="baseTable">
          <tbody>
            <tr className="firstRow">
              <td>ردیف</td>
              <td>شماره فاکتور</td>
              <td>شناسه فاکتور</td>
              <td>کد مشتری</td>
              <td>رساننده</td>
              <td>تحویل گیرنده</td>
              <td>بازه تحویل</td>
              <td>زمان تحویل</td>
              <td>آدرس</td>
              <td>
                تعداد کالای
                <br /> پارت تحویل
              </td>
              <td>
                تعداد کالای
                <br /> تحویل شده
              </td>
              {/* <th>تحویل</th> */}
              <td className="priceCell">بدهکار</td>
              <td className="priceCell">پرداخت نقدی</td>
              <td className="priceCell">پرداخت کارتخوان</td>
              <td className="priceCell">پرداخت از قبل</td>
              <td className="priceCell">مانده</td>
              <td>جزییات</td>
              <td>پرداختی</td>
            </tr>
            {remainInfo.map((items, index) => (
              <>
                <tr key={index}>
                  <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                  <td>{items.invoice.invoiceNum}</td>
                  <td>
                    <Link
                      to={{
                        pathname: '/baskets',
                        search: `?invoiceId=${items.invoice.invoiceId}&userCode=`
                      }}
                      target="_blank"
                    >
                      {items.invoice.invoiceId}
                    </Link>
                  </td>
                  <td>
                    <Link target="_blank" to={`/base/users/persina/${items.customer.userCode}`}>
                      {items.customer.userCode}
                    </Link>
                  </td>
                  <td title={items.driver === null ? '' : items.driver.mobile}>
                    {items.driver == null ? '-' : items.driver.name}
                  </td>
                  <td>{items.invoice.recipientName}</td>
                  <td>
                    {jMoment(items.planDate).format('jYY/jM/jD') +
                      ' , ' +
                      items.planTimeFrom.substr(0, 5) +
                      ' - ' +
                      items.planTimeTo.substr(0, 5)}
                  </td>
                  <td>{items.dispatchDate === null ? '-' : jMoment(items.dispatchDate).format('jYY/jM/jD HH:mm')}</td>
                  <td>{items.invoice.address}</td>
                  <td className="smallTd">{items.totalInfo.totalCount}</td>
                  <td className="smallTd">{items.totalInfo.deliveredCount}</td>
                  {/* <td>{items.deliveredBetween ? 'در بازه' : 'خارج از بازه'}</td> */}

                  <td className="priceCell">{accounting.formatMoney(items.totalInfo.payableAmount, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(items.payment.cash, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(items.payment.card, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(items.payment.prePaid, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(items.remainAmount, '', ',')}</td>
                  <td>
                    <Link
                      to={`/itemBascket/${items.deliveryPackId}/${items.invoice.invoiceNum}/${
                        items.invoice.invoiceId
                      }/${items.invoice.buyerName}`}
                      target="_blank"
                    >
                      <img src={require('../../image/details.svg')} alt="" />
                    </Link>
                  </td>
                  <td>
                    <Link
                      to={`/detailsPaid/${items.detailId}/${items.invoice.invoiceId}/${
                        items.driver == null ? '-' : items.driver.name
                      }/${items.driver == null ? '-' : items.driver.personId}`}
                      target="_blank"
                    >
                      <img
                        style={
                          items.detailId == null
                            ? {display: 'none'}
                            : {
                                display: 'block',
                                margin: 'auto'
                              }
                        }
                        src={require('../../image/details.svg')}
                        alt=""
                      />
                    </Link>
                  </td>
                </tr>
                {singleDriver && (
                  <tr>
                    <td className="longTd" colSpan={19}>
                      توضیحات : {items.invoice.description === null ? '' : items.invoice.description}
                    </td>
                  </tr>
                )}
              </>
            ))}
            <tr>
              <td colSpan={9}>مجموع</td>
              <td>{aggregation.totalInfo ? aggregation.totalInfo.totalCount : ''}</td>
              <td>{aggregation.totalInfo ? aggregation.totalInfo.deliveredCount : ''}</td>

              <td className="priceCell">
                {accounting.formatMoney(aggregation.totalInfo ? aggregation.totalInfo.payableAmount : '', '', ',')}
              </td>
              <td className="priceCell">
                {accounting.formatMoney(aggregation.payment ? aggregation.payment.cash : '', '', ',')}
              </td>
              <td className="priceCell">
                {accounting.formatMoney(aggregation.payment ? aggregation.payment.card : '', '', ',')}
              </td>
              <td className="priceCell">
                {accounting.formatMoney(aggregation.payment ? aggregation.payment.prePaid : '', '', ',')}
              </td>
              <td className="priceCell">{accounting.formatMoney(aggregation.remainAmount, '', ',')}</td>
              <td colSpan={2} />
            </tr>
          </tbody>
        </table>
        <Modal isOpen={this.state.modal} toggle={this.toggle} size="sm">
          <ModalHeader toggle={this.toggle}>نمایش امضا</ModalHeader>
          <ModalBody>
            <div className="imageSign">
              <img src={urlSign} alt="" />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.handleCancel}>
              بستن
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}
export default RemainDriverComponent
